import "client-only";

import { toast } from "react-toastify";

export const showSuccessToast = (message: string = "Success") => {
  toast.success(message);
};

export const showErrorToast = (message: string = "Error") => {
  toast.error(message);
};

export const showInfoToast = (message: string = "Info") => {
  toast.info(message);
};
